import { motion } from "framer-motion";
import PlayerCard from "./PlayerCard";

export default function TopPerformers({ data }) {
  if (!data) return null;

  const { top_hitters = [], top_pitchers = [] } = data;

  return (
    <section data-testid="top-performers">
      <h2 className="font-bebas text-2xl sm:text-3xl tracking-tight text-white mb-4">
        TOP PERFORMERS
      </h2>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Top Hitters */}
        <div>
          <h3 className="font-bebas text-xl tracking-tight text-astros-orange mb-3">
            HITTERS
          </h3>
          <div className="space-y-3">
            {top_hitters.map((player, index) => (
              <motion.div
                key={player.id}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <PlayerCard player={player} type="hitter" compact />
              </motion.div>
            ))}
            {top_hitters.length === 0 && (
              <p className="text-astros-muted text-sm">No data available</p>
            )}
          </div>
        </div>

        {/* Top Pitchers */}
        <div>
          <h3 className="font-bebas text-xl tracking-tight text-astros-orange mb-3">
            PITCHERS
          </h3>
          <div className="space-y-3">
            {top_pitchers.map((player, index) => (
              <motion.div
                key={player.id}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <PlayerCard player={player} type="pitcher" compact />
              </motion.div>
            ))}
            {top_pitchers.length === 0 && (
              <p className="text-astros-muted text-sm">No data available</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
